module.exports = __webpack_public_path__ + "static/media/external-link.7ecd4294.png";